export interface BaseColorProperties {
  textBgColor: string;
}

export interface BaseItemProperties extends BaseColorProperties {
  id: string;
  customId: string;
  activationRule: string;
  isGenericRepeatItem: boolean;
}

export const DEFAULT_BASE_PROPERTIES: BaseItemProperties = {
  id: '',
  customId: '',
  activationRule: '',
  isGenericRepeatItem: false,
  textBgColor: ''
};
